const SystemNewsPage = () => import('@views/system/NewsPage')

export default {
  path: 'news',
  name: 'SystemNewsPage',
  component: SystemNewsPage,
}
